import Cart from "@/components/Cart.jsx";
import { cart_path, catalog_path } from "@/routes.js";
import { Link } from "@inertiajs/react";
import Menu from "@/components/Menu.jsx";
import React, { useState, useEffect } from "react";
import { CartProvider, useCart } from "@/contexts/cart.jsx";
import Footer from "~/components/Footer.jsx";
import Header from "~/components/Header.jsx";

import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/zoom";
import "swiper/css/keyboard";
import "swiper/css/grid";

import "@/entrypoints/swiper.css";
import GetContactPopup from "../components/GetContactPopup";
import PersonalDataPolicyAgreement from "../components/PersonalDataPolicyAgreement";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function Layout(props) {
  const { children, taxons } = props;

  return (
    <CartProvider cart={props.cart}>
      <Header />
      <main className="pt-26 lg:pt-0">
        <div>{children}</div>
        <ScrollToTopButton />

        {!import.meta.env.SSR && (
          <>
            <GetContactPopup />
            <PersonalDataPolicyAgreement />
          </>
        )}
      </main>
      <Footer />
    </CartProvider>
  );
}
